import { isPlainObj } from "../aide";
import { encodeBase64 } from "./base64";

// Generates a query string from the given object
export const getQs = obj => {
  const entries = (isPlainObj(obj) && Object.entries(obj)) || [];

  return entries.length > 0
    ? "?" +
        entries
          .map(([key, val]) => {
            if (val !== undefined) {
              const value = typeof val === "object" ? encodeBase64(JSON.stringify(val)) : val;
              return `${key}=${value}`;
            }
            return val;
          })
          .filter(i => i)
          .join("&")
    : "";
};

// Determines if a URL is absolute or not
export const isAbsoluteUrl = (url = "") => url.startsWith("//") || /^(f|ht)tps?:\/\//i.test(url);

// Conditionally binds a relative URL to the API / client root
export const getUrl = (url = "", params) =>
  isAbsoluteUrl(url) ? url : (params.clientId == "50002" ? GLOBALS.TRACFONE_API_ROOT : GLOBALS.API_ROOT) + url;

// Cleans up a URL by returning a protocol indipendent version
export const cleanUrl = (url = "") => url.replace(/https?:\/\//, "//");

// Parses a query string and returns an object
export const parseQs = qs => [...new URLSearchParams(qs).entries()].reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {});

// TODO: Use the URLSearchParams parser instead
// Replaces a given query param on the given url
export const replaceUrlParam = (url, paramName, paramValue) => {
  if (url == null || url == "" || paramValue == null || paramValue == "") {
    return url;
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/\?$/, "");
  return url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue;
};
